import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { leads } from '../data/mockData';

const { FiSearch, FiFilter, FiArrowLeft, FiCopy, FiCheck, FiInfo, FiX } = FiIcons;
const money = (value) => `${value.toLocaleString('en-US')} ر.س`;

export function LeadsPage({ navigate }) {
  const [search, setSearch] = useState('');
  const [tab, setTab] = useState('الكل');
  const [service, setService] = useState('الكل');
  const filtered = leads.filter((lead) => {
    const matchesSearch = lead.id.includes(search) || lead.service.includes(search) || lead.source.toLowerCase().includes(search.toLowerCase());
    const matchesTab = tab === 'الكل' || (tab === 'قابل للاستعادة' ? lead.score >= 70 : lead.status === tab);
    return matchesSearch && matchesTab && (service === 'الكل' || lead.service === service);
  });

  return (
    <div className="data-page">
      <PageTitle title="العملاء المحتملون" subtitle="حلل بيانات العملاء والتحويل والمتابعة التشغيلية." />
      <div className="table-tools">
        <div className="search-box"><SafeIcon icon={FiSearch} /><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="ابحث برقم العميل أو الخدمة..." /></div>
        <select value={service} onChange={(event) => setService(event.target.value)}><option>الكل</option>{[...new Set(leads.map((item) => item.service))].map((item) => <option key={item}>{item}</option>)}</select>
      </div>
      <div className="tabs">{['الكل', 'ناجح', 'مفقود', 'قابل للاستعادة'].map((item) => <button className={tab === item ? 'active' : ''} onClick={() => setTab(item)} key={item}>{item}</button>)}</div>
      <LeadTable data={filtered} navigate={navigate} />
    </div>
  );
}

function LeadTable({ data, navigate }) {
  return (
    <div className="table-wrap">
      <table>
        <thead><tr><th>العميل</th><th>التاريخ</th><th>الخدمة</th><th>المصدر</th><th>القيمة</th><th>الحالة</th><th>سبب الخسارة</th><th>المتابعات</th><th>المنسق</th><th>قابلية الاستعادة</th></tr></thead>
        <tbody>
          {data.map((lead) => (
            <tr key={lead.id} onClick={() => navigate(`/opportunity/${lead.id}`)}>
              <td><b>عميل #{lead.id}</b></td><td>{lead.date}</td><td>{lead.service}</td><td>{lead.source}</td><td>{money(lead.value)}</td>
              <td><span className={`status ${lead.status === 'ناجح' ? 'success' : 'lost'}`}>{lead.status}</span></td><td>{lead.reason}</td><td>{lead.followups}</td><td>{lead.owner}</td>
              <td>{lead.score ? <span className="score">{lead.score}%</span> : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {!data.length && <div className="empty-inline"><SafeIcon icon={FiSearch} /><h3>لا توجد نتائج مطابقة</h3><p>جرّب تغيير البحث أو عوامل التصفية.</p></div>}
    </div>
  );
}

export function RecoverablePage({ navigate }) {
  const [reason, setReason] = useState('الكل');
  const recoverable = leads.filter((lead) => lead.score >= 65 && (reason === 'الكل' || lead.reason === reason));

  return (
    <div className="data-page">
      <PageTitle title="فرص الاستعادة" subtitle="حدد Cencey فرصًا مفقودة قد يكون من المفيد التواصل معها مرة أخرى." />
      <div className="filter-row">
        {['الخدمة', 'سبب الخسارة', 'قابلية الاستعادة', 'المنسق', 'التاريخ'].map((filter) => (
          filter === 'سبب الخسارة'
            ? <select key={filter} value={reason} onChange={(event) => setReason(event.target.value)}><option>الكل</option>{[...new Set(leads.map((lead) => lead.reason))].filter((item) => item !== '—').map((item) => <option key={item}>{item}</option>)}</select>
            : <button key={filter}><SafeIcon icon={FiFilter} /> {filter}</button>
        ))}
      </div>
      <div className="opportunity-grid">
        {recoverable.map((lead) => (
          <article className="opportunity-card" key={lead.id}>
            <div className="opportunity-head"><span><b>عميل #{lead.id}</b><small>{lead.service}</small></span><span className="score large">{lead.score}% — {lead.score > 85 ? 'مرتفعة' : 'جيدة'}</span></div>
            <dl><div><dt>القيمة المقدّرة</dt><dd>{money(lead.value)}</dd></div><div><dt>سبب الخسارة</dt><dd>{lead.reason}</dd></div><div><dt>آخر تواصل</dt><dd>{lead.last}</dd></div><div><dt>المتابعات</dt><dd>{lead.followups}</dd></div><div><dt>المنسق</dt><dd>{lead.owner}</dd></div></dl>
            <button className="btn secondary full" onClick={() => navigate(`/opportunity/${lead.id}`)}>عرض التحليل <SafeIcon icon={FiArrowLeft} /></button>
          </article>
        ))}
      </div>
      <p className="estimate-note"><SafeIcon icon={FiInfo} /> قابلية الاستعادة تقدير تحليلي يعتمد على البيانات المتاحة ولا يضمن استعادة العميل.</p>
    </div>
  );
}

export function OpportunityDetail({ id, navigate }) {
  const lead = leads.find((item) => item.id === id) || leads[0];
  const [message, setMessage] = useState('');
  const [copied, setCopied] = useState(false);

  const generate = () => setMessage('مرحبًا، نتمنى أن تكون بخير. أردنا فقط المتابعة معك بخصوص استفسارك السابق عن زراعة الأسنان. إذا كان لديك أي سؤال حول العلاج أو خيارات الدفع، يسعد فريقنا بمساعدتك.');
  const copy = async () => {
    await navigator.clipboard?.writeText(message);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="detail-page">
      <button className="back-link" onClick={() => navigate('/recoverable')}>العودة لفرص الاستعادة</button>
      <div className="detail-heading"><div><span>عميل #{lead.id}</span><h1>لماذا ضاعت هذه الفرصة؟</h1></div><span className="score large">{lead.score}% — مرتفعة</span></div>
      <section className="detail-grid">
        <article className="panel detail-summary">
          <div><small>السبب الرئيسي</small><strong>{lead.reason}</strong></div>
          <div><small>السبب الثانوي</small><strong>عدم المتابعة</strong></div>
          <div><small>القيمة المقدّرة</small><strong>{money(lead.value)}</strong></div>
          <div><small>قابلية الاستعادة</small><strong className="green">{lead.score}% — مرتفعة</strong></div>
        </article>
        <article className="insight-detail">
          <span className="analysis-label">تحليل Cencey</span>
          <p>أظهر العميل اهتمامًا أوليًا بالخدمة، لكنه توقف عن الرد بعد معرفة السعر، ولم يتم تسجيل متابعة ثانية.</p>
          <div><b>الإجراء المقترح</b><p>أعد التواصل مع العميل مع التركيز على قيمة العلاج وخيارات الدفع أو الاستشارة المتاحة.</p></div>
          <button className="btn primary" onClick={generate}>إنشاء رسالة متابعة</button>
        </article>
      </section>
      {message && (
        <section className="message-box">
          <div><h3>رسالة متابعة مقترحة</h3><button onClick={() => setMessage('')}><SafeIcon icon={FiX} /></button></div>
          <p>{message}</p>
          <button className="btn secondary" onClick={copy}><SafeIcon icon={copied ? FiCheck : FiCopy} /> {copied ? 'تم النسخ' : 'نسخ الرسالة'}</button>
          <small>لن يرسل Cencey الرسالة. يمكنك نسخها واستخدامها عبر القناة المناسبة.</small>
        </section>
      )}
    </div>
  );
}

function PageTitle({ title, subtitle }) {
  return <header className="page-header"><div><h1>{title}</h1><p>{subtitle}</p></div></header>;
}